const updatePatch = (initialValue, newValue, path, patches) => {
  if (initialValue) {
    if (newValue && newValue !== initialValue) {
      patches.push({
        op: 'replace',
        path,
        value: newValue
      });
    } else if (!newValue) {
      patches.push({
        op: 'remove',
        path
      });
    }
  } else if (newValue) {
    patches.push({
      op: 'add',
      path,
      value: newValue
    });
  }
};

export const getPartnerContactInfoUpdatePayload = ({
  name,
  email,
  line1,
  line2,
  city,
  state,
  country,
  postCode,
  homePage,
  phone,
  otherContactDetails,
  initialPartnerName,
  initialPartnerEmail,
  initialAddressLine1,
  initialAddressLine2,
  initialCity,
  initialState,
  initialCountry,
  initialPostCode,
  initialHomePage,
  initialPhone,
  initialOtherContactDetails
}) => {
  const patches = [];
  updatePatch(initialPartnerName, name, '/name', patches);
  updatePatch(initialPartnerEmail, email, '/email', patches);
  updatePatch(initialAddressLine1, line1, '/address/line1', patches);
  updatePatch(initialAddressLine2, line2, '/address/line2', patches);
  updatePatch(initialCity, city, '/address/city', patches);
  updatePatch(initialState, state, '/address/state', patches);
  updatePatch(initialCountry, country.name, '/address/country', patches);
  updatePatch(initialPostCode, postCode, '/address/postCode', patches);
  updatePatch(initialHomePage, homePage, '/vendorLinks/homePage', patches);
  updatePatch(initialPhone, phone, '/phone', patches);
  updatePatch(initialOtherContactDetails, otherContactDetails, '/otherContactDetails', patches);
  return patches;
};